import React from 'react';
import classNames from 'classnames';

import styles from './ReferralProgressBar.module.scss';

export const ReferralProgressBar = ({ title = 'Application strength', applicationStrength = 0 }) => (
  <div className={styles.progressContainer}>
    <label className={styles.formLabel} htmlFor="progress">
      {title}
      <span>{applicationStrength}%</span>
    </label>
    <div className={styles.progressBarBackground}>
      <div
        className={classNames(styles.progressBarFill, {
          [styles.progressBarFillComplete]: applicationStrength === 100,
        })}
        style={{ width: `${applicationStrength}%` }}
      />
    </div>
  </div>
);
